import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  // Define text colors using the new silver palette for consistency
  const primaryTextColor = "text-silver-light"; // Very light gray/silver
  const secondaryTextColor = "text-silver-medium"; // Medium gray/silver
  const tertiaryTextColor = "text-silver-dark"; // Darker gray/silver

  return (
    <footer className="bg-off-black text-silver-medium py-4">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-between gap-6">
          {/* Company Info */}
          <div className="w-full md:flex-1 min-w-0">
            <h2 className={`text-xl font-bold mb-2 ${primaryTextColor}`}>Riviera Tech Solutions</h2>
            <p className={`${secondaryTextColor} mb-4 leading-relaxed text-xs`}>
              {t('footer.companyDescription')}
            </p>
          </div>
          {/* Free Tools – internal linking for SEO and discovery */}
          <div className="w-full md:w-auto">
            <h3 className={`text-sm font-semibold mb-2 ${primaryTextColor}`}>
              {t('footer.toolsSectionTitle')}
            </h3>
            <nav className="flex flex-col gap-1" aria-label="Free tools and open source">
              <Link to="/open-source" className="text-silver-medium hover:text-silver-light text-xs transition-colors duration-300">
                {t('footer.openSource')}
              </Link>
              <Link to="/open-source/tools/electronics" className="text-silver-medium hover:text-silver-light text-xs transition-colors duration-300">
                {t('footer.electronicsToolkit')}
              </Link>
            </nav>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className={`${tertiaryTextColor} text-xs mb-2 md:mb-0`}>
              {t('footer.copyright', { year: new Date().getFullYear() })}
            </p>
            <div className="flex space-x-6">
              <a href="/terms" className={`${secondaryTextColor} hover:${primaryTextColor} text-xs transition-colors duration-300`}>
                {t('footer.terms')}
              </a>
              <a href="/privacy" className={`${secondaryTextColor} hover:${primaryTextColor} text-xs transition-colors duration-300`}>
                {t('footer.privacy')}
              </a>
              <a href="/cookies" className={`${secondaryTextColor} hover:${primaryTextColor} text-xs transition-colors duration-300`}>
                {t('footer.cookies')}
              </a>
              <a href="/eula" className={`${secondaryTextColor} hover:${primaryTextColor} text-xs transition-colors duration-300`}>
                EULA
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;